
<template>
  <div>
    <v-row>
      <v-col md="6" sm="6" cols="12">
        <div class="login-option-sec" @click="executeAction(0)">
          <div class="login-option-sec-image">
            <img src="../assets/Images/landing/icon-login.svg" alt="Login" />
          </div>
          <h4>Login</h4>
        </div>
      </v-col>
      <v-col md="6" sm="6" cols="12">
        <div class="login-option-sec" @click="executeAction(1)">
          <div class="login-option-sec-image">
            <img
              src="../assets/Images/landing/icon-register.svg"
              alt="Register"
            />
          </div>
          <h4>Register</h4>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { bus } from "@/main";
import router from "@/router";

var self;
export default {
  props: {
    // redirect_url: {
    //   type: String,
    //   default: "",
    // },
    page_params: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {};
  },
  created() {
    self = this;
  },
  mounted() {
    console.log(self);
  },
  watch: {},
  methods: {
    executeAction(action) {
      //alert(self.$route.fullPath)
      var redirect_url = self.$route.fullPath;
      if (self.page_params && self.page_params.redirect_url) {
        redirect_url = self.page_params.redirect_url;
      }
      var url = "";
      var clientId = self.getClientId();
      var eventId = self.getEventId();

      if (action == 0) {
        url = "/?event_id=" + eventId + "&redirect_url=" + redirect_url;
        self.closeLoginRegDecision();
        router.push(url);
      } else if (action == 1) {
        bus.$emit("toggleLoader", true);
        self.getCheckoutFormJson(
          clientId,
          eventId,
          1,
          true,
          redirect_url,
          true
        );
        self.closeLoginRegDecision();
      }
    },
  },
};
</script>